<div class="app-container medical-campaign-saf">
  <app-header [campaignType]="'medical'" (onLangChange)="setLanguage($event)"></app-header>
  <app-card-view cardClass="full-card h-630">
    <app-basic [info]="info" [hidden]="!(param==='basic')"></app-basic>
    <app-advance-detail [info]="info" [hidden]="!(param==='advance')"></app-advance-detail>
    <app-description [draft]="draft" [info]="info" [hidden]="!(param==='desc')"></app-description>
  </app-card-view>
</div>
